import { useSelector } from 'react-redux';
import type { IReduxState } from '../../../configureStore';
import type { ICustomControlRequestReadSentProps } from '../../pages/customControls/GGZBther/v1/GgzbTherV1RequestReadSent';
import { RequestStatus } from '../../../../common/enums/requestStatus';
import { ButtonContainer } from '../common';
import { CancelProcessButton } from './CancelProcessButton';
import { ChangeEmailAddressForInvitationsButton } from './ChangeEmailAddressForInvitationsButton';
import { EditRequestButton } from './EditRequestButton';
import { GetAccessToCounselingButton } from './GetAccessToCounselingButton';
import { TakeRequestButton } from './TakeRequestButton';

export function RequestCounselingReadButtons(props: ICustomControlRequestReadSentProps) {
    const isManager = useSelector((state: IReduxState) => state.authentication.isManager);

    if (isManager) {
        return null;
    }

    return (
        <ButtonContainer
            alignRight
            buttons={getRequestCounselingReadButtons(props)}
        />
    );
}

function getRequestCounselingReadButtons(props: ICustomControlRequestReadSentProps) {
    const buttons = [
        <EditRequestButton
            editRequest={props.editRequest}
            request={props.request}
        />,
        <TakeRequestButton
            reloadProcess={props.reloadProcess}
            request={props.request}
        />,
        <ChangeEmailAddressForInvitationsButton
            emailadres={props.request.customControlData.emailadres}
            invitations={props.invitations}
            reloadRequest={props.reloadRequest}
            request={props.request}
        />,
        <GetAccessToCounselingButton
            reloadRequest={props.reloadRequest}
            request={props.request}
        />,
    ];

    if (props.request.status === RequestStatus.draft) {
        buttons.push(
            <CancelProcessButton
                cancelProcess={props.removeProcess}
                request={props.request}
                serviceCode={props.serviceCode}
            />
        );
    }

    return buttons;
}
